module.exports = __webpack_public_path__ + "img/thumbnail_Addax_f_normal.602635bd.png";